<template>
  <div>
    <span v-if="state === 'created'" class="created mr-1">C</span>
    <span v-if="state === 'scheduled'" class="created mr-1 ">S</span>
    <span v-if="state === 'company_assign'" class="created mr-1 ">CA</span>
    <span v-if="state === 'blocked'" class="created blocked mr-1">B</span>
    <span v-if="state === 'completed'" class="created completed mr-1 ">C</span>
    <span v-if="state === 'approved'" class="created completed mr-1">A</span>
    <span v-if="state === 'in_progress'" class="created progress mr-1">I</span>
    <span v-if="state === 'reopened'" class="created re-opened mr-1">R</span>
    <span
      v-if="state === 'pending_approval'"
      class="created pending-approval mr-1"
      >P</span
    >
  </div>
</template>
<script>
export default {
  name: "TaskStateIcon",

  props: {
    state: {
      type: String
    }
  }
};
</script>

<style scoped>
.created {
  padding: 3px;
  border-radius: 20%;
  background-color: #9da7ad;
  color: white;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
}

.progress {
  background-color: #00cbfd;
  color: #00fcff;
}
.completed {
  background-color: #38f033;
}
.re-opened {
  background-color: #fee94e;
}
.pending-approval {
  background-color: #ffb429;
}
.blocked {
  background-color: #ff3d3b;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/_Atoms/TaskStateIcon.vue